import React from 'react'

const About = () => {
    return (
        <div name='about' className='w-full h-screen bg-gradient-to-b from-blue-900 via-black to-black text-white'>


            <div className=' max-w-screen-lg p-5 mx-auto flex flex-col justify-center w-full h-full'>

                <div className='mx-auto flex justify-center flex-col w-full h-full'>

                    <div className='pb-8 font-signature text-4xl  font-semibold '>
                        <p className=''><span className='text-red-700'>A</span>bout</p>
                    </div>

                    <p className='font-second text-lg mt-6'>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Non eligendi, reiciendis, doloribus magnam quod soluta quisquam ratione minima possimus eaque, impedit saepe quia nemo debitis tempore! Accusamus illo modi cupiditate iure possimus quisquam? Facilis, quibusdam dolore, facere adipisci quod cum nisi sunt voluptatum fugit aut omnis, ex ullam iure veniam!
                    </p>

                    <br />

                    <p className='font-second text-lg'>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi laudantium laborum minus corrupti dolorum temporibus, tempore rem iure eum perferendis dolores culpa pariatur at? Vero autem saepe perferendis vel possimus earum tempore sequi voluptatum totam magnam? Deserunt explicabo alias quasi consectetur nihil labore harum maiores sapiente modi. In, repellat rem!
                    </p>
                </div>

            </div>
        </div>
    )
}

export default About
